export const GENRES = ["Hip-Hop", "R&B", "Pop", "Trap", "Afrobeats", "Electronic", "Lo-Fi", "Rock", "Cinematic", "Other"];

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">{label}</span>
    {children}
    {hint && <span className="block text-[11px] text-slate-500">{hint}</span>}
  </label>
);

export const GenreSelect = ({ value, onChange, testId }) => (
  <select data-testid={testId} required value={value} onChange={onChange} className="nw-input appearance-none">
    <option value="" disabled>Choose a genre</option>
    {GENRES.map((g) => <option key={g} value={g}>{g}</option>)}
  </select>
);
